import { SubscriptionData } from '@zet/zet-prime'
import { create } from 'zustand'

interface SubscriptionState {
  subscription: SubscriptionData | null
  setSubscription: (subscription: SubscriptionData | null) => void
  clearSubscription: () => void
}

export const useSubscriptionStore = create<SubscriptionState>((set) => ({
  subscription: null,

  setSubscription: (subscription) => set({ subscription }),

  clearSubscription: () => set({ subscription: null }),
}))
